<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter" id="for"><a id="pagexi"></a>foreword by gerry dawes</h1>
<p class="indent">Over the past five years, tapas bars have become increasingly popular, along with their steady stream of small plates such as grilled mushrooms, <em>patatas bravas, gambas al ajillo, jamón Ibérico, croquetas</em>, stuffed <em>piquillo</em> peppers, and hundreds of other small-portion Spanish—and not-so-Spanish—dishes.</p>
<p class="indent">Yankee Connecticut might be the last place you’d expect a tapas bar and restaurant to be successful, but Andy Pforzheimer and his business partner, Sasa Mahr-Batuz, have proved that tasty, quickly prepared Spanish-inspired food, a wonderful wine list, and the lively, informal ambience for which tapas bars are famous can be a hit anywhere. They began their Barcelona Restaurant and Wine Bar concept several years ago with a single modest place across from a new movie theater in a then-gentrifying commercial section of South Norwalk (SoNo). The original Barcelona boomed, expanded into a full restaurant in its SoNo locale, and has since grown into a chain of five. Andy and Sasa are obviously bullish about tapas; they are preparing to open a sixth location in Stamford.</p>
<p class="indent">Tapas are going mainstream, and are heading toward the same general acceptance as pizza and sushi. And Barcelona will be a major player in making tapas as “American” as pizza, sushi, and, who knows, apple pie. For me, a forty-year veteran of gastronomic and wine travel in Spain, driving an hour from my home in the Hudson River valley to one of the Barcelona Restaurant and Wine Bars to enjoy a meal from the Spanish-inspired tapas menu and a good bottle of wine from the well-chosen list is the next best thing to being in Spain.</p>
<p class="center"><a id="pagexii"></a><img alt="" src="OEBPS/images/xii-1.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780740790683_epub_for_r1.vue?0d7ef69e